import { render, staticRenderFns } from "./RecallDetail.vue?vue&type=template&id=46dc569a&"
import script from "./RecallDetail.vue?vue&type=script&lang=js&"
export * from "./RecallDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports